import React from 'react';
import { BrowserRouter as Router, Route, useRouteMatch } from 'react-router-dom';
import * as paths from './ReportsBoardContainer/paths';
import EasyToDriveContainer from './ReportsBoardContainer/ComercialsReports/EasyToDriveContainer';
import EnduroMarketContainer from './ReportsBoardContainer/ComercialsReports/EnduroMarketContainer';
import HighMotosContainer from './ReportsBoardContainer/ComercialsReports/HighMotosContainer';
import TotalMarkerContainer from './ReportsBoardContainer/ComercialsReports/TotalMarkerContainer';
import StreetMarketContainer from './ReportsBoardContainer/ComercialsReports/StreetMarketContainer';
import TotalIndustryCompanyContainer from './ReportsBoardContainer/MarketShareReports/TotalIndustryCompanyContainer';
import MarkertShareEasyToDriverCompany from './ReportsBoardContainer/MarketShareReports/MarkertShareEasyToDriverCompany';
import MarkertHighRangeCompany from './ReportsBoardContainer/MarketShareReports/MarkertHighRangeCompany';
import MarkertEnduroCompany from './ReportsBoardContainer/MarketShareReports/MarkertEnduroCompany';
import MarkertStreetCompany from './ReportsBoardContainer/MarketShareReports/MarkertStreetCompany';
import MarketShareTotalResult from './ReportsBoardContainer/MarketShareReports/MarketShareTotalResult';
import MEIIndividualContainer from './ReportsBoardContainer/MeiMobility/MEIIndividualContainer';
import MEIMarketTotalsContainer from './ReportsBoardContainer/MeiMobility/MEIMarketTotalsContainer';
import MEITotalElectricSalesContainer from './ReportsBoardContainer/MeiMobility/MEITotalElectricSalesContainer';
import MEITotalSalesContainer from './ReportsBoardContainer/MeiMobility/MEITotalSalesContainer';
import Total4WMarketContainer from './ReportsBoardContainer/4wContainerReports/Total4WMarketContainer';
import Total4WMarketProductsContainer from './ReportsBoardContainer/4wContainerReports/Total4WMarketProductsContainer';
import MEIElectricBikesContainer from './ReportsBoardContainer/MeiMobility/MEIElectricBikesContainer';
import MEISkateBoardContainer from './ReportsBoardContainer/MeiMobility/MEISkateBoardContainer ';
import Total3WMarketContainer from './ReportsBoardContainer/4wContainerReports/Total3WMarketContainer';
import ImportsSparePartsContainer from './ReportsBoardContainer/SparePartsContainer/ImportsSparePartsContainer';
import ImportsOriginalSparePartsContainer from './ReportsBoardContainer/SparePartsContainer/ImportsOriginalSparePartsContainer';
import ImportsOriginalIndiaSparePartsContainer from './ReportsBoardContainer/SparePartsContainer/ImportsOriginalIndiaSparePartsContainer';
import ImportsOriginalEspecialSparePartsContainer from './ReportsBoardContainer/SparePartsContainer/ImportsOriginalEspecialSparePartsContainer';
import ImportTyresContainer from './ReportsBoardContainer/SparePartsContainer/ImportTyresContainer';
import ImportBateryContainer from './ReportsBoardContainer/SparePartsContainer/ImportBateryContainer';
import ReportBoardContainer from './ReportsBoardContainer/ReportBoardContainer';

const ReportsBoard = () => {
  const { path } = useRouteMatch();
  return (
    <>
      <Router>
        <Route exact path={`${path}`} component={ReportBoardContainer} />
        <Route
          exact
          path={`${path}${paths.TOTAL_MARKETS}`}
          component={TotalMarkerContainer}
        />
        <Route
          exact
          path={`${path}${paths.TOTAL_EASY_DRIVE}`}
          component={EasyToDriveContainer}
        />
        <Route
          exact
          path={`${path}${paths.TOTAL_ALTA_GAMA}`}
          component={HighMotosContainer}
        />
        <Route
          exact
          path={`${path}${paths.TOTAL_ENDURO}`}
          component={EnduroMarketContainer}
        />
        <Route
          exact
          path={`${path}${paths.TOTAL_STREET}`}
          component={StreetMarketContainer}
        />
        <Route
          exact
          path={`${path}${paths.TOTAL_MARKET_SHARE}`}
          component={TotalIndustryCompanyContainer}
        />
        <Route
          exact
          path={`${path}${paths.TOTAL_MARKET_EASYTODRIVER}`}
          component={MarkertShareEasyToDriverCompany}
        />
        <Route
          exact
          path={`${path}${paths.TOTAL_MARKET_HIGH_RANGE}`}
          component={MarkertHighRangeCompany}
        />
        <Route
          exact
          path={`${path}${paths.TOTAL_MARKET_ENDURO}`}
          component={MarkertEnduroCompany}
        />
        <Route
          exact
          path={`${path}${paths.TOTAL_MARKET_STREET}`}
          component={MarkertStreetCompany}
        />
        <Route
          exact
          path={`${path}${paths.TOTAL_MARKET_TOTAL}`}
          component={MarketShareTotalResult}
        />
        <Route
          exact
          path={`${path}${paths.MEI_IMPORTS_INDIVIDUAL}`}
          component={MEIIndividualContainer}
        />
        <Route
          exact
          path={`${path}${paths.MEI_MARKET}`}
          component={MEIMarketTotalsContainer}
        />
        <Route
          exact
          path={`${path}${paths.MEI_MARKET_TOTAL_SALES}`}
          component={MEITotalSalesContainer}
        />
        <Route
          exact
          path={`${path}${paths.MEI_MARKET_TOTAL_ELECTRIC}`}
          component={MEITotalElectricSalesContainer}
        />
        <Route
          exact
          path={`${path}${paths.MEI_MARKET_ELECTRIC_BIKERS}`}
          component={MEIElectricBikesContainer}
        />
        <Route
          exact
          path={`${path}${paths.MEI_MARKET_SKATEBOARD}`}
          component={MEISkateBoardContainer}
        />
        <Route
          exact
          path={`${path}${paths.MARKET_TOTAL_4W}`}
          component={Total4WMarketContainer}
        />
        <Route
          exact
          path={`${path}${paths.MARKET_TOTAL_PRODUCT}`}
          component={Total4WMarketProductsContainer}
        />
        <Route
          exact
          path={`${path}${paths.MARKET_TOTAL_3W}`}
          component={Total3WMarketContainer}
        />
        <Route
          exact
          path={`${path}${paths.SPARE_PARTS_TOTAL}`}
          component={ImportsSparePartsContainer}
        />
        <Route
          exact
          path={`${path}${paths.SPARE_PARTS_ORIGINAL}`}
          component={ImportsOriginalSparePartsContainer}
        />
        <Route
          exact
          path={`${path}${paths.SPARE_PARTS_ORIGINAL_INDIA}`}
          component={ImportsOriginalIndiaSparePartsContainer}
        />
        <Route
          exact
          path={`${path}${paths.SPARE_PARTS_ORIGINAL_ESPECIAL}`}
          component={ImportsOriginalEspecialSparePartsContainer}
        />
        <Route
          exact
          path={`${path}${paths.SPARE_PARTS_TYRES}`}
          component={ImportTyresContainer}
        />
        <Route
          exact
          path={`${path}${paths.SPARE_PARTS_BATERY}`}
          component={ImportBateryContainer}
        />
      </Router>
    </>
  );
};

export default ReportsBoard;
